/**
 * Shared resolver for the `‹Token›` pattern system used across the card customizer.
 *
 * Extracted from `fillPageWithEventInfo` so recipient addressing (postcards) can resolve
 * the same `‹…›` syntax without duplicating the regex. Behaviour is intentionally identical
 * to the original: an unmatched token is left literal (so a missing field is visible rather
 * than silently blanked), and the whole result is trimmed.
 *
 * The token grammar is `‹` (U+2039) + word chars + `›` (U+203A), matched by `/‹(\w+)›/g`.
 */
export const fillPattern = (pattern: string, data: Record<string, string | undefined>): string => {
  // Trim in case any field is empty.
  return pattern.replace(/‹(\w+)›/g, (match, key) => data[key] ?? match).trim();
};
